define(
    'widgets/fp_accesscontrol/viewmodel',[
        'durandal/app',
        "providers/dataprovider"
    ],
    function (app, dataProvider) {
        var ctor = function () { };
        
        ctor.prototype.activate = function (settings) {
            var self = this;

            self.$selectTeam = null;
            self.selectTeam = null;
            self.$selectPerson = null;
            self.selectPerson = null;

            self.$gridTeam = null;
            self.gridTeam = null;
            self.$gridPerson = null;
            self.gridPerson = null;

            self.settings = settings;

            self.i19n = settings.data.i19n;
            self.id = settings.data.id;
            self.isEdit = settings.data.isEdit == undefined ? true : settings.data.isEdit;

            
            self.settings.data.initialize(function () { self.initialize(); });
            self.settings.data.refresh(function () { self.refresh(); });
            self.settings.data.save(function (h) { self.save(h); });
            self.settings.data.cancel(function () { self.cancel(); });
            if (self.settings.data.edit != undefined)
                self.settings.data.edit(function (e) { self.isEdit = e; self.initialize(); });
            //if (self.settings.data.selectable != undefined)
            //    self.settings.data.selectable(function (b) { self.selectable(b); });
        };
        ctor.prototype.attached = function () {
            var self = this;

            self.$gridTeam = $("#accesscontrol-grid-team" + self.id);
            self.$gridTeamO = self.$gridTeam.clone();
            self.$gridPerson = $("#accesscontrol-grid-person" + self.id);
            self.$gridPersonO = self.$gridPerson.clone();

            self.$selectTeam = $("#accesscontrol-select-team" + self.id);
            self.$selectPerson = $("#accesscontrol-select-person" + self.id);
            
            self.initialize();
        };

        ctor.prototype.initialize = function () {            
            var self = this;

            function createColumnRadio(field, title, name, value, hideButtonOnGuest) {
                var h = hideButtonOnGuest ? '#= isGuest ? "visibility:hidden" : ""#' : '';
                //var e = '<input class="k-grid-rights" name="' + name + '" style="height:18px; ' + h + '" type="radio" data-bind="checked:rights" value="' + value + '"/>';
                //var t = '<input disabled="disabled" class="k-grid-rights" name="' + name + '#=id#" style="height:18px; ' + h + '" type="radio" value="' + value + '" #= rights == "' + value + '" ? "checked=checked" : "" # />';
                var edit = self.settings.data.edit != undefined ? (!self.isEdit ? 'disabled="disabled"' : '') : '';
                var t = '<input ' + edit + ' class="k-grid-rights" id="' + name + '#=id#" name="' + name + '#=id#" style="height:18px; ' + h + '" type="radio" value="' + value + '" #=rights=="' + value + '" ? "checked=checked":""# />';
                
                var ht = title + ' <i id="role-help-text" class="fa fa-question-circle"></i>';
                var c = { field: field, title: title, width: 50, template: t, headerTemplate: ht, attributes: { style: "text-align:center;" } };

                return c;
            }
            function cloneGrid() {
                if (self.gridTeam != null) {

                    self.gridTeam.destroy();
                    self.gridTeam = null;

                    self.gridPerson.destroy();
                    self.gridPerson = null;

                    if (self.$gridTeam) {
                        var $teamP = self.$gridTeam.parent();
                        self.$gridTeam.remove();
                        self.$gridTeam = self.$gridTeamO.clone();
                        $teamP.append(self.$gridTeam);

                        var $personP = self.$gridPerson.parent();
                        self.$gridPerson.remove();
                        self.$gridPerson = self.$gridPersonO.clone();
                        $personP.append(self.$gridPerson);
                    }
                }
            }
            function buildTeamSelect() {
                self.selectTeam = self.$selectTeam.kendoMultiSelect({
                    dataTextField: "name",
                    dataValueField: "id",
                    dataSource: new kendo.data.DataSource({
                        transport: {
                            read: function (callbacks) {
                                callbacks.success(self.settings.data.dataSource.teamSelect);
                            }
                        },                
                        pageSize: 999
                    })
                }).data('kendoMultiSelect');
            }
            function buildPersonSelect() {
                self.selectPerson = self.$selectPerson.kendoMultiSelect({
                    dataTextField: "name",
                    dataValueField: "id",
                    dataSource: new kendo.data.DataSource({
                        transport: {
                            read: function (callbacks) {
                                callbacks.success(self.settings.data.dataSource.personSelect);
                            }
                        },
                        pageSize: 999
                    })
                }).data('kendoMultiSelect');
            }
            function buildTeamGrid() {
                var columns = [
                    { field: "id", hidden: true },
                    { field: "name", title: self.i19n.to.team, width: 300 }
                ];

                var c1 = _.map(self.settings.data.dataSource.rightsColumn,
                    function (itm) {                        
                        return createColumnRadio(itm.field, itm.name, 'team', itm.value, itm.hideButtonOnGuest);
                    });

                //var l = _.last(c1);
                //if(l) delete l.width;

                var c2 = {
                    command: [
                        //{ name: "edit", text: self.i19n.to.edit },
                        { name: "destroy", text: self.i19n.to.delete } //self.i19n.to.remove
                    ],
                    title: "&nbsp;",
                    width: 160
                };

                columns = columns.concat(c1);
                columns = columns.concat(c2);

                self.gridTeam = self.$gridTeam.kendoGrid({
                    dataSource: getTeamGridDataSource(),
                    dataBound: function () {
                        this.table.off("click", ":radio", toggleCheck);
                        this.table.on("click", ":radio", toggleCheck);

                        function toggleCheck(e) {
                            e.stopPropagation();

                            var $cell = $(e.target).closest("td");

                            self.gridTeam.select($cell);
                        }
                    },
                    resizable: true,
                    reorderable: false,
                    sortable: false,
                    selectable: self.isEdit ? "cell" : null,
                    columns: columns,
                    scrollable: false, 
                    editable: { mode: "inline", confirmation: false },
                    change: function (e) {
                        var s = this.select();
                        if (s[0] == undefined)
                            return;

                        var di = this.dataItem(s[0].parentNode);
                        var r = $('#team' + di.id, s[0]).val();
                        if (r) {
                            var q = _.find(self.settings.data.dataSource.teamGrid, function (itm) { return itm.id == di.id; });
                            if (q) {
                                q.rights = r;
                            }

                            $('#team' + di.id, s[0]).prop('checked', true);
                        }
                    }
                }).data("kendoGrid");

                self.gridTeam.thead.kendoTooltip({
                    content: kendo.template($("#access-control-help-template").html()),
                    filter: 'th.k-header[data-field^="__"]',
                    position: "bottom",
                    width: 350,
                    //content: function (e) {
                    //    var target = e.target; // element for which the tooltip is shown

                    //    var helpText = "";
                    //    var field = $(target).attr("data-field");

                    //    if (field == "__r60") {
                    //        helpText = "View Library / List Item / Folder / Documents<br/>Preview documents<br/>View document details / document history<br/>Update document details<br/>Download document<br/>Check Out and Open document<br/>Open document Read Only<br/>New document (Use as Template)<br/>Add New documents<br/>Save documents<br/>Save New Version of document<br/>Share documents<br/>Share Link to documents<br/>Export Details<br/>Copy/Move documents<br/>Bulk Download documents<br/>Replace documents<br/>Modify Field value<br/>Check In / Check Out documents<br/>Delete documents<br/>Delete Libraries, List Items and Folders<br/>Purge documents<br/>Create, update and delete folders<br/>Set folder access control";
                    //    }
                    //    if (field == "__r50") {
                    //        helpText = "View Library / List Item / Folder / Documents<br/>Preview documents<br/>View document details / document history<br/>Update document details<br/>Download document<br/>Check Out and Open document<br/>Open document Read Only<br/>New document (Use as Template)<br/>Add New documents<br/>Save documents<br/>Save New Version of document<br/>Share documents<br/>Share Link to documents<br/>Export Details<br/>Copy/Move documents<br/>Bulk Download documents<br/>Replace documents<br/>Modify Field value<br/>Check In / Check Out documents<br/>Delete documents<br/>Delete Libraries, List Items and Folders<br/>Purge documents<br/>Create, update and delete folders";
                    //    }
                    //    if (field == "__r40") {
                    //        helpText = "View Library / List Item / Folder / Documents<br/>Preview documents<br/>View document details / document history<br/>Update document details<br/>Download document<br/>Check Out and Open document<br/>Open document Read Only<br/>New document (Use as Template)<br/>Add New documents<br/>Save documents<br/>Save New Version of document<br/>Share documents<br/>Export Details<br/>Bulk Download documents<br/>Replace documents<br/>Modify Field value<br/>Check In / Check Out documents<br/>Delete documents";
                    //    }
                    //    if (field == "__r30") {
                    //        helpText = "View Library / List Item / Folder / Documents<br/>Preview documents<br/>View document details / document history<br/>Download document<br/>Check Out and Open document<br/>Open document Read Only<br/>New document (Use as Template)<br/>Export Details<br/>Bulk Download documents";
                    //    }
                    //    if (field == "__r20") {
                    //        helpText = "View Library / List Item / Folder / Documents<br/>Preview documents<br/>View document details / document history<br/>Download document<br/>Check Out and Open document<br/>Open document Read Only<br/>New document (Use as Template)<br/>Export Details<br/>Bulk Download documents";
                    //    }
                    //    if (field == "__r10") {
                    //        helpText = "Add New documents<br/>Save documents<br/>Save New Version of document";
                    //    }
                    //    if (field == "__r0") {
                    //        helpText = "Has no access to a Library / List Item / Folder";
                    //    }

                    //    if (helpText == "")
                    //        helpText = $(target).attr("data-title");

                    //    return helpText;

                    //    //var title = $(target).attr("data-title");

                    //    //if (!title)
                    //    //    return "";


                    //    //return title; 
                    //}
                });
            };
            function buildPersonGrid() {
                var columns = [
                    { field: "id", hidden: true },
                    { field: "name", title: self.i19n.to.person, width: 300}
                ];

                var c1 = _.map(self.settings.data.dataSource.rightsColumn,
                    function (itm) {
                        return createColumnRadio(itm.field, itm.name, 'person', itm.value, itm.hideButtonOnGuest);
                    });

                //var l = _.last(c1);
                //if(l) delete l.width;

                var c2 = {
                    command: [
                        //{ name: "edit", text: self.i19n.to.edit },
                        { name: "destroy", text: self.i19n.to.delete } //self.i19n.to.remove
                    ],
                    title: "&nbsp;",
                    width: 160
                };

                columns = columns.concat(c1);
                columns = columns.concat(c2);

                self.gridPerson = self.$gridPerson.kendoGrid({
                    dataSource: getPersonGridDataSource(),
                    dataBound: function () {
                        this.table.off("click", ":radio", toggleCheck);
                        this.table.on("click", ":radio", toggleCheck);

                        function toggleCheck(e) {
                            e.stopPropagation();

                            var $cell = $(e.target).closest("td");

                            self.gridPerson.select($cell);
                        }
                    },
                    resizable: true,
                    reorderable: false,
                    sortable: false,
                    selectable: self.isEdit ? "cell" : null,
                    columns: columns,
                    scrollable: false,
                    editable: { mode: "inline", confirmation: false },
                    change: function (e) {
                        var s = this.select();
                        if (s[0] == undefined)
                            return;

                        var di = this.dataItem(s[0].parentNode);
                        var r = $('#person' + di.id, s[0]).val();
                        if (r) {
                            var q = _.find(self.settings.data.dataSource.personGrid, function (itm) { return itm.id == di.id; });
                            if (q) {
                                q.rights = r;
                            }

                            $('#person' + di.id, s[0]).prop('checked', true);
                        }
                    }
                }).data("kendoGrid");

                self.gridPerson.thead.kendoTooltip({
                    content: kendo.template($("#access-control-help-template").html()),
                    filter: 'th.k-header[data-field^="__"]',
                    position: "top",
                    width: 350                    
                });
            };
            function getTeamGridDataSource() {
                var schema = {
                    model: {
                        id: "id",
                        fields: {
                            id: { type: "string" },
                            name: { type: "string" },
                            rights: { type: "string" },
                            isGuest: { type: "bool" }
                        }
                    }
                };

                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            callbacks.success(self.settings.data.dataSource.teamGrid);
                        },
                        update: function (callbacks) {
                            //var q;
                            //var d = self.settings.data.dataSource.teamGrid;
                            //var g = self.settings.data.dataSource.teamSelect;
                            //q = _.findWhere(d, { id: callbacks.data.id });
                            //d = _.without(d, q);
                            //g = g.concat(q);

                            //self.settings.data.dataSource.teamSelect = g;
                            //self.settings.data.dataSource.teamGrid = d;

                            callbacks.success();

                            //self.refresh();

                            //var data = {
                            //    libraryId: vm.id,
                            //    teamId: callbacks.data.id,
                            //    roleId: callbacks.data.rights
                            //};

                            //dataProvider
                            //    .accesscontrollibrary
                            //    .updateTeamRoleInLibrary(data)
                            //    .done(function (result) {
                            //        loadAccess()
                            //            .done(function (result) {
                            //                vm.accessData.refresh();

                            //                callbacks.success();
                            //            })
                            //            .fail(function (e) { });
                            //    })
                            //    .fail(function (result) {
                            //        vm.accessData.teamGrid.cancelChanges();

                            //        result.stopPropagation = true;

                            //        callbacks.error(result.error);
                            //    });
                        },
                        create: function (callbacks) {
                            callbacks.success();
                        },
                        destroy: function (callbacks) {
                            var q;                            
                            var d = self.settings.data.dataSource.teamGrid;
                            var g = self.settings.data.dataSource.teamSelect;
                            q = _.findWhere(d, { id: callbacks.data.id });
                            d = _.without(d, q);
                            g = g.concat(q);
                
                            self.settings.data.dataSource.teamSelect = g;
                            self.settings.data.dataSource.teamGrid = d;

                            callbacks.success();

                            self.refresh();
                        }
                    },
                    schema: schema,
                    pageSize: 50
                });
            }
            function getPersonGridDataSource() {
                var schema = {
                    model: {
                        id: "id",
                        fields: {
                            id: { type: "string" },
                            name: { type: "string" },
                            rights: { type: "string" },
                            isGuest: { type: "bool" }
                        }
                    }
                };

                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            callbacks.success(self.settings.data.dataSource.personGrid);
                        },
                        update: function (callbacks) {
                            callbacks.success();

                            //var data = {
                            //    libraryId: vm.id,
                            //    personId: callbacks.data.id,
                            //    roleId: callbacks.data.rights
                            //};

                            //dataProvider
                            //    .accesscontrollibrary
                            //    .updatePersonRoleInLibrary(data)
                            //    .done(function (result) {
                            //        loadAccess()
                            //            .done(function (result) {
                            //                vm.accessData.refresh();

                            //                callbacks.success();
                            //            })
                            //            .fail(function (e) { });
                            //    })
                            //    .fail(function (result) {
                            //        vm.accessData.personGrid.cancelChanges();

                            //        result.stopPropagation = true;

                            //        callbacks.error(result.error);
                            //    });
                        },
                        create: function (callbacks) {
                            callbacks.success();
                        },
                        destroy: function (callbacks) {
                            var q;
                            var d = self.settings.data.dataSource.personGrid;
                            var g = self.settings.data.dataSource.personSelect;
                            q = _.findWhere(d, { id: callbacks.data.id });
                            d = _.without(d, q);
                            g = g.concat(q);

                            self.settings.data.dataSource.personSelect = g;
                            self.settings.data.dataSource.personGrid = d;

                            callbacks.success();

                            self.refresh();
                        }
                    },
                    schema: schema,
                    pageSize: 50
                });
            }

            if (self.selectTeam == null || self.selectPerson == null) {
                buildTeamSelect();
                buildPersonSelect();
            }

            cloneGrid();

            buildTeamGrid();
            buildPersonGrid();
            
            resizeGrid(self.$gridPerson, self.settings.data.h);
            resizeGrid(self.$gridTeam, self.settings.data.h);
        };
        ctor.prototype.refresh = function () {
            var self = this;

            self.selectTeam.dataSource.read();
            self.selectPerson.dataSource.read();            

            self.gridTeam.dataSource.read();
            self.gridPerson.dataSource.read();
            
            self.selectTeam.value(null);
            self.selectPerson.value(null);

            resizeGrid(self.$gridTeam, self.settings.data.h);
            resizeGrid(self.$gridPerson, self.settings.data.h);
        };
        ctor.prototype.save = function (h) {
            var self = this;

            var d = {
                teams: self.settings.data.dataSource.teamGrid,
                persons: self.settings.data.dataSource.personGrid
            };
            
            h(d);
        };
        ctor.prototype.cancel = function () {
            var self = this;
        };

        //ctor.prototype.selectable = function (b) {
        //    var self = this;

        //    $("#accesscontrol-grid-team table" + self.id).toggleClass('k-selectable');
        //    $("#accesscontrol-grid-person table" + self.id).toggleClass('k-selectable');

        //    console.warn('test');
        //};

        ctor.prototype.addTeamClick = function () {
            var self = this;

            if (self.selectTeam.value().length > 0) {
                var q = [];
                var d = self.settings.data.dataSource.teamSelect;
                var g = self.settings.data.dataSource.teamGrid;
                _.map(self.selectTeam.value(), function (itm) {
                    q = _.findWhere(d, { id: itm });
                    d = _.without(d, q);
                    q.rights = q.isGuest ? 30 : 60; //full control or read only
                    q = [q];
                    g = g.concat(q);
                });

                self.settings.data.dataSource.teamSelect = d;
                self.settings.data.dataSource.teamGrid = g;
                
                setTimeout(function () {
                    self.selectTeam.dataSource.read();
                    self.gridTeam.dataSource.read();

                    self.selectTeam.value(null);

                    resizeGrid(self.$gridTeam, self.settings.data.h);
                }, 500);
            }
        };
        ctor.prototype.addPersonClick = function () {
            var self = this;

            if (self.selectPerson.value().length > 0) {
                var q = [];
                var d = self.settings.data.dataSource.personSelect;
                var g = self.settings.data.dataSource.personGrid;
                _.map(self.selectPerson.value(), function (itm) {
                    q = _.findWhere(d, { id: itm });
                    d = _.without(d, q);
                    q.rights = q.isGuest ? 30 : 60; //full control or read only
                    q = [q];
                    g = g.concat(q);
                });

                self.settings.data.dataSource.personSelect = d;
                self.settings.data.dataSource.personGrid = g;

                setTimeout(function () {
                    self.selectPerson.dataSource.read();
                    self.gridPerson.dataSource.read();

                    self.selectPerson.value(null);

                    resizeGrid(self.$gridPerson, self.settings.data.h);
                }, 500);
            }
        };       

        return ctor;

        function resizeGrid($grid, h) {
            if (!$grid)
                return;
            
            $grid.data("kendoGrid").resize();
        }
    });
